// Initialize Hotel A.S.K Grand Rooms in Firebase
import { saveRoom } from './firebase';

export async function initializeHotelRooms() {
  console.log('Initializing 27 rooms for Hotel A.S.K Grand...');
  
  const rooms = [
    // Suite Rooms (101-105) - 5 rooms
    ...Array.from({ length: 5 }, (_, i) => ({
      room_number: `${101 + i}`,
      type: 'Suite' as const,
      floor: 1,
      status: 'available' as const,
      price: 1750,
      amenities: ['AC', 'TV', 'Wi-Fi', 'Hot Water', 'Premium Bedding', 'Work Desk', 'City View'],
      current_guest: null,
      check_in: null,
      check_out: null,
      last_cleaned: new Date().toISOString(),
      maintenance_notes: '',
      booking_history: []
    })),
    
    // Royal Rooms Floor 2 (201-207) - 7 rooms
    ...Array.from({ length: 7 }, (_, i) => ({
      room_number: `${201 + i}`,
      type: 'Royal' as const,
      floor: 2,
      status: 'available' as const,
      price: 1500,
      amenities: ['AC', 'TV', 'Wi-Fi', 'Hot Water', 'Double Bed'],
      current_guest: null,
      check_in: null,
      check_out: null,
      last_cleaned: new Date().toISOString(),
      maintenance_notes: '',
      booking_history: []
    })),
    
    // Royal Rooms Floor 3 (301-307) - 7 rooms
    ...Array.from({ length: 7 }, (_, i) => ({
      room_number: `${301 + i}`,
      type: 'Royal' as const,
      floor: 3,
      status: 'available' as const,
      price: 1500,
      amenities: ['AC', 'TV', 'Wi-Fi', 'Hot Water', 'Double Bed'],
      current_guest: null,
      check_in: null,
      check_out: null,
      last_cleaned: new Date().toISOString(),
      maintenance_notes: '',
      booking_history: []
    })),
    
    // Single Rooms (401-408) - 8 rooms
    ...Array.from({ length: 8 }, (_, i) => ({
      room_number: `${401 + i}`,
      type: 'Single' as const,
      floor: 4,
      status: 'available' as const,
      price: 900,
      amenities: ['AC', 'TV', 'Wi-Fi', 'Work Desk'],
      current_guest: null,
      check_in: null,
      check_out: null,
      last_cleaned: new Date().toISOString(),
      maintenance_notes: '',
      booking_history: []
    }))
  ];

  try {
    let successCount = 0;
    for (const room of rooms) {
      const success = await saveRoom(room.room_number, room);
      if (success) {
        successCount++;
        console.log(`✓ Room ${room.room_number} initialized`);
      } else {
        console.error(`✗ Failed to initialize room ${room.room_number}`);
      }
    }
    
    console.log(`\n✅ Successfully initialized ${successCount}/${rooms.length} rooms!`);
    return successCount === rooms.length;
  } catch (error) {
    console.error('Error initializing rooms:', error);
    return false;
  }
}

// Room breakdown:
// Floor 1: Suite 101-105 (5 rooms) @ ₹1,750/night
// Floor 2: Royal 201-207 (7 rooms) @ ₹1,500/night
// Floor 3: Royal 301-307 (7 rooms) @ ₹1,500/night
// Floor 4: Single 401-408 (8 rooms) @ ₹900/night
// Total: 27 rooms
